export default () => {
  return "https://pertobilingueadm.com.br/pews";
  // return 'http://192.168.1.101:3004';
};
